import { useState } from "react";
import styled from 'styled-components'
import Select, { ActionMeta, components } from "react-select";
import { Flex, Heading, Text, Box } from "rebass/styled-components";
import { RbCircledChecked, RbCircledUnchecked } from "../components/RadioButton";
import { ReactSelectStyles } from "../styles/ReactSelectStyles";
import { Constants } from "../utils/Constants";
import { IThumbnailAipRecipeOutput } from "../graphql/types/queries/recipes";
import { IArticle } from "../graphql/types/queries/articles";
import Recipes from "./messages/components/modalsContents/Recipes";
import Articles from "./messages/components/modalsContents/Articles";
import SpeakerSeries from "./messages/components/modalsContents/SpeakerSeries";
import ThyroidGuides from "./messages/components/modalsContents/ThyroidGuides";
import Modal from "styled-react-modal";
import ViewRecipe from "./messages/components/modalsContents/ViewRecipe";
import ViewArticle from "./messages/components/modalsContents/ViewArticle";

const Divider = styled(Box)`
  width: 100%;
  height: 1px;
  background-color: #C9C9C9;
  margin-top: 8px;
  margin-bottom: 8px;
  @media screen and (min-width: 68.8125em) {
  margin-top: 25px;
  margin-bottom: 25px;
  }
`

const Container = styled(Flex)`
  padding: ${() => `${Constants.OUTLETS_PADDING_MOBILE}px`};
  padding-top: ${() => `${Constants.OUTLETS_PADDING_TOP_MOBILE}px`};
  width: 100%;
  padding-bottom: 0;
  @media screen and (min-width: 68.8125em) {
  padding: ${() => `${Constants.OUTLETS_PADDING}px`};
  padding-top: ${() => `${Constants.OUTLETS_PADDING_TOP}px`};
  min-width: ${() => `${Constants.OUTLETS_WIDTH}px`};
  /* padding-bottom: 0; */
  }
`
enum EOptionsResourcesValues {
  'Recipes',
  'Articles',
  'SpeakerSeries',
  'ThyroidGuides',
}
interface IOptionsResources {
  value: EOptionsResourcesValues
  label: string;
}

const optionsResources: Array<IOptionsResources> = [
  { value: EOptionsResourcesValues.ThyroidGuides, label: 'Thyroid Guides' },
  { value: EOptionsResourcesValues.Recipes, label: 'Recipes' },
  { value: EOptionsResourcesValues.Articles, label: 'Articles' },
  { value: EOptionsResourcesValues.SpeakerSeries, label: 'Speaker Series' },
]

const Option = (props: any) => {
  return (
    <components.Option {...props}>
      <Flex alignItems={'center'}>
        {props.isSelected ? (
          <RbCircledChecked />
        ) : <RbCircledUnchecked />}

        <Text ml={2}>{props.children}</Text>
      </Flex>
    </components.Option>
  );
};

const Resources = () => {
  const [selectedResourceType, setSelectedResourceType] = useState<IOptionsResources>(optionsResources[0])
  const [viewRecipe, setViewRecipe] = useState<IThumbnailAipRecipeOutput | null>()
  const [viewArticle, setViewArticle] = useState<IArticle | null>()

  return (
    <Container flexDirection={'column'} style={{ height: '100%', overflow: 'hidden' }} >
      <Flex mb={[0,3,3]}>
        <Heading mr={3}>Resources</Heading>
        <Select
          isSearchable={false}
          styles={ReactSelectStyles.initialStyles}
          options={optionsResources}
          value={selectedResourceType}
          onChange={(option: IOptionsResources | null, actionMeta: ActionMeta<IOptionsResources>) => {
            if (!option) return
            setSelectedResourceType(option)
          }}
          components={{ Option }} />
      </Flex>

      <Flex flexDirection={'column'} mt={2} justifyContent="flex-start" overflowY={['hidden', 'auto', 'auto']} >
        <Divider />
        {selectedResourceType.value === EOptionsResourcesValues.Recipes && (
          <Recipes
            viewRecipe={(recipe: IThumbnailAipRecipeOutput) => setViewRecipe(recipe)}
            canSelect={false}
            selectedRecipes={[]}
            setSelectedRecipes={(recipe) => {
            }} />
        )}
        {selectedResourceType.value === EOptionsResourcesValues.Articles && (
          <Articles
            viewArticle={(article) => setViewArticle(article)}
            canSelect={false}
            selectedArticles={[]}
            setSelectedArticles={(article) => {
            }}
          />
        )}
        {selectedResourceType.value === EOptionsResourcesValues.SpeakerSeries && (
          <SpeakerSeries
            selectedSpeakerSeries={[]}
            canSelect={false}
            setSelectedSpeakerSeries={(speakerSerie) => {
            }}
          />
        )}
        {selectedResourceType.value === EOptionsResourcesValues.ThyroidGuides && (
          <ThyroidGuides
            selectedSpeakerSeries={[]}
            canSelect={false}
            setSelectedSpeakerSeries={(speakerSerie) => {
            }}
          />
        )}
      </Flex>
      {!!viewRecipe && (
        <Modal
          isOpen={!!viewRecipe}
          onBackgroundClick={(e) => setViewRecipe(null)}
          onEscapeKeydown={(e) => {
            console.log('STOP')
            e.preventDefault()
            e.stopImmediatePropagation()
            e.stopPropagation()
            setViewRecipe(null)
          }}>
          <Flex flexDirection={'column'} height={['calc(90% - 47px)', '90%','90%']}
            style={{
              background: '#f1f3f5',
              borderRadius: '20px',
              maxHeight: '100%',
              zIndex: 1005,
              overflow: 'hidden'
            }}>
            <ViewRecipe
              canSelect={false} thumbnail={viewRecipe} selectedRecipes={[]} onSelect={() => {
              }} onCancel={() => setViewRecipe(null)} />
          </Flex>
        </Modal>
      )}
      {!!viewArticle && (
        <Modal
          isOpen={!!viewArticle}
          onBackgroundClick={(e) => setViewArticle(null)}
          onEscapeKeydown={(e) => {
            console.log('STOP')
            e.preventDefault()
            e.stopImmediatePropagation()
            e.stopPropagation()
            setViewArticle(null)
          }}>
          <Flex flexDirection={'column'} height={['calc(90% - 47px)', '90%','90%']}
            style={{
              background: '#f1f3f5',
              borderRadius: '20px',
              maxHeight: '100%',
              zIndex: 1005,
              overflow: 'hidden'
            }}>
            <ViewArticle
              canSelect={false}
              article={viewArticle}
              selectedArticles={[]}
              onSelect={(article?: IArticle) => {
              }}
              viewRelatedPost={article => setViewArticle(article)}
              onCancel={() => setViewArticle(null)}
            />
          </Flex>
        </Modal>
      )}
    </Container>
  )
}

export default Resources